import { LastResults } from '@isophi/parents-api';

export const hasAnyResult = (results: LastResults) => !!results?.questionnaire;
